<div class="dialog-container">
  <lib-dialog-header (closeClick)="closeClicked()" i18n>
    Reject Golf Industry Hours
  </lib-dialog-header>
  <div class="dialog-content">
    <div i18n>Are you sure you want to reject these golf industry hours?<br><br>
      Please provide a reason for rejecting the submission. This note will be sent to the member.
    </div>
    <lib-textarea-form-field label="Reason For Rejection"
                             i18n-label
                             hintText="Optional"
                             i18n-hintText
                             [maxCharacters]="500"
                             [isSubmitted]="isSubmitted()"
                             [inputFormControl]="reasonForRejectionFormControl"></lib-textarea-form-field>
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="closeClicked()" i18n>
      Cancel
    </lib-button>
    <lib-button [type]="ButtonType.primary" (buttonClick)="updateToRejectedClicked()" i18n>
      Reject Submission
    </lib-button>
  </div>
</div>
